let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dyp0t")).then(() => parcelRequire('b0ztm'));